import { generateApi } from 'utils/api'

const { selectResource, selectResources, useResource, useResources } =
  generateApi('resource', ['vendor'])

export { selectResource, selectResources, useResource, useResources }
